export const rafThrottle = (fn: (...args: any[]) => void) => {
  let requestId: number | null = null;

  const later = (args: any[]) => () => {
    requestId = null;
    fn(...args);
  };

  const throttled = (...args: any[]) => {
    if (requestId === null) {
      requestId = requestAnimationFrame(later(args));
    }
  };

  throttled.cancel = () => {
    if (requestId !== null) {
      cancelAnimationFrame(requestId);
      requestId = null;
    }
  };

  return throttled;
};
